import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Collections from './pages/Collections';

function App() {
  return (
    <Router>
      <div className="bg-luxury-blue min-h-screen text-luxury-black">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/collections" element={<Collections />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
